import { useEffect, useState } from 'react';
import { clientConfig } from '../config/clientConfig';
import { hubspot } from '../utils/hubspot';
import { consentManager } from '../utils/consentManager';

export default function HubspotScript() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Check consent before loading (HubSpot loads GTM/Meta Pixel!)
    const checkAndLoad = async () => {
      if (!clientConfig.isHubspotEnabled) {
        return;
      }

      // Check if we should load (handles California vs non-California logic)
      const canLoad = await consentManager.shouldLoadGTM();
      
      if (canLoad) {
        setShouldLoad(true);
      }
    };

    checkAndLoad();

    // Listen for user interaction event (from California users clicking buttons)
    const handleUserInteraction = () => {
      if (clientConfig.isHubspotEnabled) {
        setShouldLoad(true);
      }
    };

    window.addEventListener('userInteracted', handleUserInteraction);

    return () => {
      window.removeEventListener('userInteracted', handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    if (!shouldLoad) {
      return;
    }

    const portalId = clientConfig.hubspotPortalId;
    
    if (!portalId) {
      console.warn('HubSpot Portal ID not configured');
      return;
    }

    // Add HubSpot script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${portalId}.js`;
    
    // Set up onload handler to initialize content type after script loads
    script.onload = () => {
      // Set the content type
      hubspot.setContentType('landing-page');
      
      // Set any default page properties
      hubspot.setPageProperty('source', 'loan-application');
    };
    
    document.body.appendChild(script);
    
    return () => {
      const existingScript = document.getElementById('hs-script-loader');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, [shouldLoad]);
  
  return null;
}